<script lang="ts">
	import { backgroundJobs, activeJobsCount } from '$lib/stores/backgroundJobs';
	import { fly } from 'svelte/transition';

	let showDetails = $state(false);
</script>

{#if $activeJobsCount > 0}
	<div class="fixed bottom-4 right-4 z-50" transition:fly={{ y: 100, duration: 300 }}>
		<div class="max-w-sm rounded-lg border border-gray-200 bg-white p-4 shadow-lg">
			<div class="mb-2 flex items-center justify-between">
				<h3 class="font-semibold text-gray-900">Background Tasks</h3>
				<button
					type="button"
					onclick={() => (showDetails = !showDetails)}
					class="text-gray-500 hover:text-gray-700"
				>
					{showDetails ? '−' : '+'}
				</button>
			</div>

			<div class="flex items-center gap-2 text-sm text-gray-600">
				<div class="flex items-center gap-1">
					<div class="h-2 w-2 animate-pulse rounded-full bg-blue-500"></div>
					<span>{$activeJobsCount} active task{$activeJobsCount === 1 ? '' : 's'}</span>
				</div>
			</div>

			{#if showDetails}
				<div class="mt-3 space-y-2 border-t pt-3">
					{#each Object.values($backgroundJobs) as job (job.id)}
						<div class="text-sm">
							<div class="flex items-center justify-between">
								<span class="font-medium">
									{#if job.type === 'complete_orders'}
										Completing Orders
									{:else}
										{job.type}
									{/if}
								</span>
								<span class="text-xs text-gray-500">
									{#if job.status === 'waiting'}
										Queued
									{:else if job.status === 'active'}
										Processing
									{:else if job.status === 'completed'}
										✓ Complete
									{:else if job.status === 'failed'}
										✗ Failed
									{/if}
								</span>
							</div>

							{#if job.orderCount}
								<div class="text-xs text-gray-500">
									Processing {job.orderCount} orders
								</div>
							{/if}

							{#if job.progress?.message}
								<div class="mt-1 text-xs text-gray-600">
									{job.progress.message}
								</div>
							{/if}

							{#if job.status === 'active' && job.progress?.percent !== undefined}
								<div class="mt-1 h-1.5 rounded-full bg-gray-200">
									<div
										class="h-1.5 rounded-full bg-blue-500 transition-all duration-300"
										style="width: {job.progress.percent}%"
									></div>
								</div>
							{/if}

							{#if job.failedReason}
								<div class="mt-1 text-xs text-red-600">
									Error: {job.failedReason}
								</div>
							{/if}
						</div>
					{/each}
				</div>
			{/if}
		</div>
	</div>
{/if}

<style>
	@keyframes pulse {
		0%,
		100% {
			opacity: 1;
		}
		50% {
			opacity: 0.5;
		}
	}

	.animate-pulse {
		animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
	}
</style>
